import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "datatables.net";
import { Routes, Route } from "react-router-dom";
//import Calendar from "./Component/Configuration/Calendar";
import Loader from "./Component/Loader/Loader";
import Layout from "./Component/Layout";
import UpdatePassword from "./Component/Authentication/UpdatePassword";
import MultiUserSelection from "./Component/Authentication/MultiUserSelection";

import { globalClickTracker } from "./utils/globalClickTracker";
const LogIn = React.lazy(() => import("./Component/Authentication/LogIn"));
const Element = React.lazy(() => import("./Pages/View/Element"));
const LogInSwitch = React.lazy(() => import("./Component/Authentication/LogInSwitch"));
const WidgetMarketplace = React.lazy(() => import("./Component/RevenueManagement/WidgetMarketplace"));
const WidgetMarketplaceDetail = React.lazy(() => import("./Component/RevenueManagement/WidgetMarketplaceDetail"));

const SnapshotMarketplace = React.lazy(() => import("./Component/RevenueManagement/SnapshotMarketplace"));
const SnapshotMarketplaceDetail = React.lazy(() => import("./Component/RevenueManagement/SnapshotMarketplaceDetail"));
const Marketplace = React.lazy(() => import("./Component/RevenueManagement/Marketplace"));
const MarketplaceDocumentViewer = React.lazy(() => import("./Component/RevenueManagement/MarketplaceDocumentViewer"));
const SSO = React.lazy(() => import("./Component/Authentication/SSO"));
const AgreementSigningRequired = React.lazy(() => import("./Component/Authentication/AgreementSigningRequired"));


function App() {
    useEffect(() => {
        const cleanup = globalClickTracker();
        return cleanup;
    }, []);
    return (
        <Routes>
            <Route
                path="/element"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <Element />
                    </React.Suspense>
                }
            />
            <Route
                path="/"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <LogIn />
                    </React.Suspense>
                }
            />
            <Route
                path="/sso"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <SSO />
                    </React.Suspense>
                }
            />
            <Route
                path="/agreementrequired"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <AgreementSigningRequired />
                    </React.Suspense>
                }
            />
            <Route
                path="/updatePassword"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <UpdatePassword />
                    </React.Suspense>
                }
            />
            <Route
                path="/userselection"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <MultiUserSelection />
                    </React.Suspense>
                }
            />
            <Route
                path="/loginswitch"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <LogInSwitch />
                    </React.Suspense>
                }
            />
            <Route
                path="/marketplace"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <Marketplace />
                    </React.Suspense>
                }
            />
            <Route
                path="/widgetmarketplace"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <WidgetMarketplace />
                    </React.Suspense>
                }
            />
            <Route
                path="/widgetmarketplace/:id"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <WidgetMarketplaceDetail />
                    </React.Suspense>
                }
            />


            <Route
                path="/snapshotmarketplace"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <SnapshotMarketplace />
                    </React.Suspense>
                }
            />
            <Route
                path="/snapshotmarketplace/:id"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <SnapshotMarketplaceDetail />
                    </React.Suspense>
                }
            />
            <Route
                path="/marketplace/:type/:id/document"
                element={
                    <React.Suspense fallback={<Loader />}>
                        <MarketplaceDocumentViewer />
                    </React.Suspense>
                }
            />
            <Route path="/*" element={<Layout />} />
        </Routes>

    );
}

export default App;
